/**
* Shows advertisement pages
*/
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_deprecated_1 = require('@angular/router-deprecated');
var clientinfo_service_1 = require('../clientinfo.service');
var http_1 = require('@angular/http');
var core_2 = require('angular2-cookie/core');
var carousel_item_1 = require('./carousel-item/carousel-item');
var Wallop = require('wallop');
var ServiceModulesComponent = (function () {
    function ServiceModulesComponent(router, clientInfo, http, params, _cookieService) {
        this.router = router;
        this.clientInfo = clientInfo;
        this.http = http;
        this.params = params;
        this._cookieService = _cookieService;
        this.needAuth = true;
    }
    ServiceModulesComponent.prototype.ngOnInit = function () {
        this.numModules = this.clientInfo.service['modules'].length;
        this.needAuth = !this.params.get('auth');
    };
    // If we have slider output choosen in admin panel. Init Wallop.js slider
    ServiceModulesComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.clientInfo.service['is_advert_slider'] == 1) {
            var el = document.querySelector('.Wallop');
            this.slider = new Wallop(el);
            this.slider.on('change', function (event) {
                var el = document.querySelector('.Wallop-item--current');
                document.getElementById('slideTitle').innerText = el['dataset'].text;
                var active = document.getElementsByClassName('dot active');
                if (active.length > 0) {
                    active[0]['style'].background = '#989898';
                    active[0].classList.remove('active');
                }
                var notactive = document.getElementsByClassName('dot');
                notactive[event.detail.currentItemIndex].classList.add('active');
                notactive[event.detail.currentItemIndex]['style'].background = '#' + _this.clientInfo.service['color.rgb'];
            });
        }
    };
    ServiceModulesComponent = __decorate([
        core_1.Component({
            selector: 'smartwifi-service-modules',
            template: require('./service-modules.template.html'),
            directives: [router_deprecated_1.ROUTER_DIRECTIVES, carousel_item_1.CarouselItem],
            providers: [core_2.CookieService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_deprecated_1.Router !== 'undefined' && router_deprecated_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof clientinfo_service_1.ClientInfoService !== 'undefined' && clientinfo_service_1.ClientInfoService) === 'function' && _b) || Object, (typeof (_c = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _c) || Object, (typeof (_d = typeof router_deprecated_1.RouteParams !== 'undefined' && router_deprecated_1.RouteParams) === 'function' && _d) || Object, (typeof (_e = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _e) || Object])
    ], ServiceModulesComponent);
    return ServiceModulesComponent;
    var _a, _b, _c, _d, _e;
}());
exports.ServiceModulesComponent = ServiceModulesComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./app/service-modules/service-modules.component.ts
 ** module id = 1001
 ** module chunks = 1
 **/